import type { IdentityUser } from '../../user/types/user';

export const BrokerProductType = {
  CreditLine: 'CreditLine',
  Consume: 'Consume',
} as const;

export interface BrokerOfferRate {
  number: number;
  date: string;
  amount: number;
}

export interface BrokerOfferDetails {
  id: string;
  brokerName: string;
  amount: number;
  numberOfRates: number;
  rates: BrokerOfferRate[];
  creditCost: number;
  totalCost: number;
  interest: number;
  productName: string;
  productType: string;
  expiresAt: string;
  isExpired: boolean;
  expiresStartSeconds: number;
  expireSecondsLeft: number;
  dailyFee: number;
  totalAmount: number;
  grantingCommission: number;
  nominalAnnualPercentageRate: number;
  effectiveAnnualRate: number;
}

export interface BrokerOfferApplicant {
  phone: string;
  firstName?: string;
  lastName?: string;
}

export interface BrokerOtpRequestResponse {
  isSuccess: boolean;
  error?: string;
}

export interface BrokerOtpConfirmRequest {
  phone: string;
  code: string;
  refUrl?: string;
}

/**
 * Volt-authorized session returned by the (proxied) broker confirm-otp.
 * Mirrors the regular signup response so the Firebase sign-in handoff is shared.
 * NOTE: the proxied token originates from Ocean — if Volt introduces a dedicated
 * authorization controller, this shape and the handoff in useBrokerOtp adapt there.
 */
export interface BrokerOtpConfirmResponse {
  isSuccess: boolean;
  error?: string;
  isNew: boolean;
  user: IdentityUser;
  token: string;
}
